import _ from 'lodash';
import { IntroAPROrRewards } from 'src/types/inputs';
import {
  CardsMarketplaceOffer,
  CardsMarketplaceOfferRewardsRecommendationCategory,
} from 'src/types/marketplace';
import { InputsReducer } from 'src/redux/reducers/inputs';
import { MethodologyPoints } from '../constants';
import { calculateScore, calculateIntroAPR } from './shared';
import { CalculatePoints, Question, MatchScore } from './types';
import { CalculateMethodology } from '../utils';
import { PurchaseSpendingCategories } from 'src/types/inputs';

const {
  TWENTY_SIX_POINTS,
  TWENTY_ONE_POINTS,
  THIRTEEN_POINTS,
  EIGHT_POINTS,
  ZERO_POINTS,
} = MethodologyPoints;

export const calculateRewardsPurchaseIntroTime: CalculatePoints = (
  {},
  offer: CardsMarketplaceOffer
) => {
  const offerIntroTime = offer?.details?.purchase_intro_time;
  if (offerIntroTime && offerIntroTime >= 12) {
    return THIRTEEN_POINTS;
  }
  return ZERO_POINTS;
};

export const calculatePurchaseSpend: CalculatePoints = (
  { purchaseSpend },
  offer: CardsMarketplaceOffer
) => {
  const promoWithSpendAmount = offer?.details?.promos?.find(
    (item) => item.spend_amount
  );
  const spendAmount = promoWithSpendAmount?.spend_amount;

  if (!!purchaseSpend && !!spendAmount && purchaseSpend >= spendAmount)
    return EIGHT_POINTS;

  return ZERO_POINTS;
};

export const calculateBestMatchPoints: CalculatePoints = (
  { purchaseSpendingCategories },
  offer: CardsMarketplaceOffer
) => {
  let rewardsPoints = ZERO_POINTS;
  const rewards = offer?.details?.rewards;
  let allRewardsRate = false;

  const userSelectedOnlyOther =
    purchaseSpendingCategories?.length === 1 &&
    purchaseSpendingCategories?.[0] === PurchaseSpendingCategories.Other;

  const matchingCategories = rewards?.filter((reward) => {
    const allCategoriesRewarded =
      reward?.recommendation_category ===
      CardsMarketplaceOfferRewardsRecommendationCategory.All;

    if (allCategoriesRewarded && reward?.rate && reward.rate > 1) {
      allRewardsRate = true;
    }

    const isCategoryIncluded =
      reward.recommendation_category &&
      purchaseSpendingCategories?.includes(
        reward.recommendation_category as any
      );

    return reward?.rate && reward.rate > 1 && isCategoryIncluded;
  });
  if (matchingCategories?.length) {
    rewardsPoints = EIGHT_POINTS;
  }

  if (
    matchingCategories?.length === purchaseSpendingCategories?.length ||
    (userSelectedOnlyOther && allRewardsRate)
  ) {
    rewardsPoints = THIRTEEN_POINTS;
  }

  rewardsPoints += allRewardsRate ? THIRTEEN_POINTS : ZERO_POINTS;

  return rewardsPoints;
};

const getQuestions = ({ introAPROrRewards }: InputsReducer): Question[] => [
  {
    availablePoints:
      introAPROrRewards === IntroAPROrRewards.IntroAPR
        ? TWENTY_ONE_POINTS
        : THIRTEEN_POINTS,
    calculate:
      introAPROrRewards === IntroAPROrRewards.IntroAPR
        ? calculateIntroAPR
        : calculateRewardsPurchaseIntroTime,
  },
  {
    availablePoints: TWENTY_SIX_POINTS,
    calculate: calculateBestMatchPoints,
  },
  {
    availablePoints: EIGHT_POINTS,
    calculate: calculatePurchaseSpend,
  },
];

const getBigPurchaseVariantScore: CalculateMethodology = (
  answers,
  offer
): MatchScore => calculateScore(answers, offer, getQuestions(answers));

export default getBigPurchaseVariantScore;
